// extracted by mini-css-extract-plugin
export default {"defaultHeader":"DefaultHeader__defaultHeader--Oks"};